import { DataTable } from "../../components/DataTable/index.tsx";
import { getCols } from "../../util/getCols.ts";
import type { View } from "../../../../../common/types.ts";
import { wrappedPlayerNameLabels } from "../../components/PlayerNameLabels.tsx";
import type { DataTableRow } from "../../components/DataTable/index.tsx";
import { wrappedPosition } from "../../util/positionNames.tsx";
import { draftProspectPreviewLimit } from "../../mobile/displayPolicies.ts";

const DraftClass = ({
	challengeNoRatings,
	hideHeading,
	offset,
	players,
	season,
}: {
	challengeNoRatings: boolean;
	fantasyDraft: boolean;
	hideHeading?: boolean;
	offset: number;
	players: View<"draftScouting">["seasons"][0]["players"];
	season: number;
}) => {
	const cols = getCols(["#", "Name", "Pos", "Age", "Ovr", "Pot"]);

	const rows: DataTableRow[] = players.slice(0, draftProspectPreviewLimit).map((p) => {
		return {
			key: p.pid,
			metadata: {
				type: "player",
				pid: p.pid,
				season,
				playoffs: "regularSeason",
			},
			data: [
				p.rank,
				wrappedPlayerNameLabels({
					pid: p.pid,
					season,
					skills: p.skills,
					defaultWatch: p.watch,
					// R5-1: the localized-name lookup keys on the full first name; passing
					// the abbreviated `firstNameShort` here fed "J." into the zh
					// transliterator and produced garbled output ("杰.·戈迪威恩"). Pass the
					// full first name for the lookup and keep `firstNameShort` for display.
					firstName: p.firstName,
					firstNameShort: p.firstNameShort,
					lastName: p.lastName,
					nameOnly: true,
				}),
				wrappedPosition(p.pos),
				p.age,
				!challengeNoRatings ? p.ovr : null,
				!challengeNoRatings ? p.pot : null,
			],
		};
	});

	return (
		<>
			{hideHeading ? null : <h2>{season}</h2>}

			<DataTable
				cols={cols}
				defaultSort={[0, "asc"]}
				name={`DraftScouting:${offset}`}
				rows={rows}
			/>
		</>
	);
};

export default DraftClass;
